import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const postLinkLite = ({ id, ...data }) =>
  axios.post(`/lite/campaigns/${id}/participate/post`, data);
